export default {
    VIEW_DATA: 'VIEW_DATA',
    VIEW_FORM: 'VIEW_FORM',
};
